import React from 'react';
import { Icon } from './Icon.js';
export const IconSquareLayoutGridFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m5.25,5.25V.5h-2C1.733.5.5,1.733.5,3.25v2h4.75Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m6.75,5.25h4.75v-2c0-1.517-1.233-2.75-2.75-2.75h-2v4.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("path", { d: "m6.75,6.75v4.75h2c1.517,0,2.75-1.233,2.75-2.75v-2h-4.75Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m5.25,6.75H.5v2c0,1.517,1.233,2.75,2.75,2.75h2v-4.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconSquareLayoutGridFill12.js.map